import Vue from 'vue'
import createAPI from 'vue-create-api'
import DownloadDialog from '@/components/download/downloadDialog'
import NegotiateDialog from '@/components/common/NegotiateDialog'
import BiddenDialog from '@/components/common/BiddenDialog'
Vue.use(createAPI)
Vue.createAPI(DownloadDialog, true);
Vue.createAPI(NegotiateDialog, true);
Vue.createAPI(BiddenDialog, true);




// WEBPACK FOOTER //
// ./src/utils/register.js